const config = [
  {
    component: 'ZlmTitle',
    options: {
      size: 'medium',
      text: '项目概况',
    },
  },
  {
    component: 'ZlmNormalDetail',
    options: {
      data: {},
    },
  },
  {
    component: 'ZlmTitle',
    options: {
      size: 'medium',
      text: '成交结果信息',
    },
  },
  // {
  //   component: 'ZlmTitle',
  //   options: {
  //     size: 'medium',
  //     text: '流标公告',
  //   },
  // },
  // {
  //   component: 'ZlmNormalDetail',
  //   options: {
  //     data: {},
  //   },
  // },
]

const { getProjectTypeName } = require('../projectType')
// const { getPurchaseTypeName } = require('../purchaseType')

const mixin = {
  data() {
    return {
      config: JSON.parse(JSON.stringify(config)),
    }
  },
  methods: {
    getData() {
      this.$request.post(`/transformToAfter/app/fee/back/queryBaseInfo`, {
        bdGuid: this.$route.query.bdGuid,
        guid: this.$route.query.guid,
        zbYiChangGuid: this.$route.query.zbYiChangGuid,
      }, { showLoading: true }).then((res) => {
        this.config[1].options.data = {
          '标段/包名称': res.data.bdName,
          '标段/包编号': res.data.bdBH2,
          '项目经理': res.data.lianXiRenName,
          '联系电话': res.data.lianXiRenMobile,
          '所属行业分类': getProjectTypeName(res.data.xmType),
        }
        // this.config[3].options.data = {
        //   '项目结果': res.data.lvYueQingKuang,
        //   '原因': res.data.lvYueQingKuang,
        //   '情况描述': res.data.lvYueQingKuang,
        //   '公告内容': res.data.lvYueQingKuang,
        // }
      })

      this.$request.post('/transformToAfter/app/home/zbjgDetail', {
        guid: this.$route.query.guid,
        bdGuid: this.$route.query.bdGuid,
      }, { showLoading: true }).then((res) => {
        if (res.data.zbFangshi === 'fz') {
          res.data.data.fzPbjgList.forEach((item) => {
            const data = {
              '成交人名称': item.tbrName,
            }
            if (res.data.data.sbxingshi === 4) {
              data['费率'] = item.zhongBiaoFeiLv
            } else {
              data['成交价(元)'] = item.cjJinE
            }
            this.config.push({
              component: 'ZlmNormalDetail',
              options: {
                data: data,
              },
            })
          })
        } else if (res.data.zbFangshi === 'zb') {
          res.data.data.jggsList.forEach((item) => {
            const data = {
              '成交人名称': item.tbrName,
            }
            if (res.data.data.sbxingshi === 4) {
              data['费率'] = item.zhongBiaoFeiLv
            } else {
              data['成交价(元)'] = item.zhongBiaoJia
            }
            this.config.push({
              component: 'ZlmNormalDetail',
              options: {
                data: data,
              },
            })
          })
        }
      })
    },
  },
}

module.exports = {
  config,
  mixin,
}
